import React from 'react';
import PropTypes from 'prop-types';
import './WorkflowTask.scss'
import classnames from 'classnames'
import HrbTranslate from '../../language/HrbTranslate';
import BlockSignalLink from '../common/BlockSignalLink';

const TaskErrorText = (props) => {
    const params = Object.assign({ BlockSignal: <BlockSignalLink /> }, props.params)
    return (
        <div className={classnames('task-error', { [props.classNames]: props.classNames })}>
            <p className='p2'><HrbTranslate text={props.errorKey} params={params} /></p>
        </div>
    )
}

TaskErrorText.propTypes = {
    errorKey: PropTypes.string.isRequired,
    classNames: PropTypes.string,
    params: PropTypes.object
}

export default TaskErrorText;
